export const Endpoints = {
	AUTH: 'auth/portal',
	AUTH_REQUEST: 'auth/portal/request',
	USER_DETAILS: 'auth/portal/user',
	PRODUCT: 'product',
	PRODUCT_SEARCH: 'product/search',
	PRODUCT_CATEGORIES: 'categories',
	PDF_CREATOR: 'pdf-creator/from-html',
	ORDER_PICKING_OVERVIEW: 'orders/overview/picking',
	ORDER_CHECKING_OVERVIEW: 'orders/overview/checking',
	ORDER_RETURNING_OVERVIEW: 'orders/overview/returning',
};

export type EndpointType = (typeof Endpoints)[keyof typeof Endpoints];
